// @flow
import * as React from 'react';
import clsx from "clsx";
import {SORT_TYPE} from "search2/filter/SearchFilter";

type Props = {
  sortOpen: boolean;
  handleClick;
  getTranslation;
};
export const UlSortType = ({sortOpen, handleClick, getTranslation}: Props) => {
  return (
    <ul className={clsx("select-list", "sort-kind-list")}
      style={{display: sortOpen ? 'block' : 'none'}}>
      <li
        onClick={(e) => handleClick(e, 'sort-click', SORT_TYPE.ACCURACY)}>{getTranslation("I18N_SEARCH_FILTER_ACCURACY")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'sort-click', SORT_TYPE.UPDATE)}>{getTranslation("I18N_SEARCH_FILTER_UPDATED")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'sort-click', SORT_TYPE.POPULAR)}>{getTranslation("I18N_SEARCH_FILTER_POPULAR")}
      </li>
    </ul>
  );
};